(function(){
  var MARKUP="<a class=\"skip\" href=\"#main-content\">Skip to builder</a>\n<div class=\"model-ribbon\"><span class=\"model-dot\" aria-hidden=\"true\"></span>Selection model \u00b7 real Sunroonga inventory \u00b7 bead sizes and pricing still to be added</div>\n<header>\n  <div class=\"nav\">\n    <div class=\"brand\"><span class=\"brand-mark\">\u2726</span> Sunroonga</div>\n    <div class=\"stock-note\" id=\"stock-note\">Loading live inventory\u2026</div>\n  </div>\n</header>\n<button class=\"mini-preview\" id=\"mini-preview\" type=\"button\" aria-label=\"Scroll back to the live bangle preview\">\n  <svg id=\"mini-stage\" viewBox=\"150 240 320 200\" aria-hidden=\"true\" focusable=\"false\"></svg>\n  <span class=\"mini-copy\"><strong>Live preview</strong><small id=\"mini-meta\">Bangle not selected</small></span>\n  <span class=\"mini-hint\" aria-hidden=\"true\">View</span>\n</button>\n\n<main id=\"main-content\" class=\"shell\">\n  <section class=\"intro\" aria-labelledby=\"page-title\">\n    <h1 id=\"page-title\">Build your bangle.</h1>\n    <p>Choose the gold bangle first, then add up to three crystal beads and two metal charms. Every selectable piece comes from the current Sunroonga Shopify catalogue.</p>\n  </section>\n\n  <ol class=\"steps\" id=\"progress\" aria-label=\"Bangle builder progress\">\n    <li class=\"active\" data-progress=\"bangle\"><span class=\"num\">1</span><span><strong>Choose the bangle</strong><small>Your required base</small></span></li>\n    <li data-progress=\"beads\"><span class=\"num\">2</span><span><strong>Add crystal beads</strong><small>Up to three</small></span></li>\n    <li data-progress=\"charms\"><span class=\"num\">3</span><span><strong>Add metal charms</strong><small>Up to two</small></span></li>\n  </ol>\n\n  <div class=\"workbench\">\n    <aside class=\"preview-column\" aria-label=\"Live bangle preview\">\n      <section class=\"preview-card\" id=\"preview-card\">\n        <div class=\"preview-head\">\n          <div><h2>Live preview</h2><p>Front-facing customer view</p></div>\n          <div class=\"preview-tools\">\n            <button class=\"assembly-button\" id=\"assembly-button\" type=\"button\" disabled aria-label=\"Play how the selected pieces thread onto the bangle\"><span aria-hidden=\"true\">\u25b6</span> Play assembly</button>\n            <span class=\"status-pill\" id=\"status-pill\">Choose bangle</span>\n          </div>\n        </div>\n        <div class=\"stage-wrap\">\n          <svg id=\"bangle-stage\" viewBox=\"0 0 620 470\" role=\"img\" aria-label=\"Empty bangle preview\"></svg>\n        </div>\n        <p class=\"scale-note\">Each selection adds one piece. Play the assembly to see it thread on. Beads with a listed millimetre size are shown at relative scale; beads without a listed size use a standard preview size.</p>\n        <p class=\"drag-hint\" id=\"drag-hint\" hidden>Drag a charm sideways to hang it anywhere between the stopper beads, drag a crystal sideways to swap its position, or drag a piece up or down away from the wire to remove it.</p>\n        <div class=\"selection-summary\" id=\"selection-summary\"></div>\n        <div class=\"preview-actions\">\n          <button class=\"primary\" id=\"cart-button\" type=\"button\" disabled>Choose the bangle to continue</button>\n          <button class=\"clear-all\" id=\"clear-button\" type=\"button\" hidden>Clear all selections</button>\n        </div>\n      </section>\n    </aside>\n\n    <div class=\"configurator\">\n      <section class=\"config-step\" id=\"step-bangle\" aria-labelledby=\"bangle-heading\">\n        <div class=\"step-head\">\n          <div class=\"step-title\"><span class=\"step-index\">1</span><div><h2 id=\"bangle-heading\">Start with the bangle</h2><p>This base is required before crystal beads and charms unlock.</p></div></div>\n        </div>\n        <div id=\"bangle-choice\"></div>\n      </section>\n\n      <section class=\"config-step locked\" id=\"step-crystals\" aria-labelledby=\"crystal-heading\" aria-disabled=\"true\">\n        <div class=\"step-head\">\n          <div class=\"step-title\"><span class=\"step-index\">2</span><div><h2 id=\"crystal-heading\">Choose your crystal beads</h2><p>Each click adds one bead, even when a listing photo shows several. Add them from left to right.</p></div></div>\n          <span class=\"count\" id=\"bead-count\">0 / 3</span>\n        </div>\n        <div class=\"inventory-grid\" id=\"crystal-grid\"></div>\n        <div class=\"selected-block\">\n          <h3>Your crystal order</h3>\n          <div id=\"selected-beads\"></div>\n        </div>\n      </section>\n\n      <section class=\"config-step locked\" id=\"step-charms\" aria-labelledby=\"charm-heading\" aria-disabled=\"true\">\n        <div class=\"step-head\">\n          <div class=\"step-title\"><span class=\"step-index\">3</span><div><h2 id=\"charm-heading\">Choose your metal charms</h2><p>Pick up to two. Letter listings ask for the initial after you choose the style.</p></div></div>\n          <span class=\"count\" id=\"charm-count\">0 / 2</span>\n        </div>\n        <div class=\"filters\" id=\"charm-filters\" aria-label=\"Filter charms\"></div>\n        <div class=\"letter-panel\" id=\"letter-panel\" hidden>\n          <h3 id=\"letter-title\">Choose an initial</h3>\n          <p id=\"letter-copy\"></p>\n          <div class=\"letters\" id=\"letters\"></div>\n        </div>\n        <div class=\"inventory-grid\" id=\"charm-grid\"></div>\n        <div class=\"selected-block\">\n          <h3>Your charm order</h3>\n          <div id=\"selected-charms\"></div>\n        </div>\n      </section>\n    </div>\n  </div>\n</main>\n\n<footer><strong>\u2726 Sunroonga</strong><br>Gold plated over brass \u00b7 waterproof finish \u00b7 prices in AUD</footer>\n<div class=\"toast\" id=\"toast\" role=\"status\" aria-live=\"polite\"></div>";
  function start(){
    var mount=document.getElementById('sunroonga-builder-mount');
    if(!mount||mount.dataset.started)return;
    mount.dataset.started='1';
    mount.innerHTML=MARKUP;
    document.body.classList.add('sunroonga-builder-page','embedded');
    try{

(function(){
  'use strict';
    var INV=window.SUNROONGA_BUILDER_DATA.INV;
    var LETTER_ASSETS=window.SUNROONGA_BUILDER_DATA.LETTER_ASSETS;
  var LETTER_RINGS={"sprite":"data:image/webp;base64,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","sprite_px":[36,102],"positions":{"20":{"A":[40.0,19,4],"B":[38.5,19,4],"C":[21.5,19,4],"D":[32.5,19,4],"E":[43.0,19,4],"F":[43.0,19,4],"G":[35.5,19,4],"H":[37.0,19,4],"I":[61.5,19,4],"J":[58.0,25.0,4],"K":[35.0,19,4],"L":[46.5,19,4],"M":[48.5,19,4],"N":[39.0,19,4],"O":[27.0,22.0,4],"P":[40.0,19,4],"Q":[76.5,19,4],"R":[39.0,19,4],"S":[33.0,22.0,4],"T":[37.5,19,4],"U":[31.0,19,4],"V":[27.0,19,4],"W":[24.5,19,4],"X":[28.5,19,4],"Y":[36.0,19,4],"Z":[38.5,19,4]},"21":{"A":[40.0,19,4],"B":[41.0,20,5],"C":[28.5,29,14],"D":[35.0,33,18],"E":[47.0,19,4],"F":[45.0,25.0,14],"G":[40.5,33,18],"H":[38.5,19,4],"I":[59.5,19,4],"J":[61.0,30,15],"K":[39.5,32,17],"L":[48.5,28,13],"M":[50.0,19,4],"N":[44.5,26,11],"O":[68.5,15,0],"P":[42.0,34,19],"Q":[74.5,19,4],"R":[42.5,29,14],"S":[51.0,42,27],"T":[40.5,38,23],"U":[39.0,35,20],"V":[33.5,30,15],"W":[26.5,19,4],"X":[36.5,27,12],"Y":[38.5,20,5],"Z":[40.0,31,16]},"22":{"A":[62.5,26,11],"B":[43.5,28,13],"C":[71.0,25,10],"D":[61.5,22,7],"E":[42.0,38,23],"F":[45.0,38,23],"G":[55.0,29,14],"H":[62.0,21,6],"I":[52.0,29,14],"J":[54.0,21,6],"K":[25.5,29,14],"L":[27.5,25,10],"M":[57.5,24,9],"N":[41.0,26,11],"O":[59.0,36,21],"P":[49.5,21,6],"Q":[56.0,27,12],"R":[47.0,35,20],"S":[50.5,21,6],"T":[56.0,29,14],"U":[72.5,43,28],"V":[80.0,28,13],"W":[45.0,30.0,31],"X":[76.0,20,5],"Y":[75.5,22,7],"Z":[62.5,26,11]}}};
  var BANGLE=INV.filter(function(p){return p.kind==='bangle'})[0];
  var BEADS=INV.filter(function(p){return p.kind==='bead'});
  var CHARMS=INV.filter(function(p){return p.kind==='charm'});
  var MAX_BEADS=3,MAX_CHARMS=2,uid=0,toastTimer=null,assemblyRun=0;
  // Charms hang from the wire between the two stopper beads and can sit anywhere in that
  // span, so each one carries its own x instead of snapping to a fixed slot. The range
  // matches the span the crystal layout already uses; the inset keeps a charm clear of
  // the stopper beads themselves.
  var CHARM_MIN_X=216,CHARM_MAX_X=404,CHARM_NUDGE=26;
  // The wire is not straight: across the decorated span its centre line dips about 12
  // units from the ends to the middle. Fitted through measurements at x=218, 314 and 404
  // of the stage (see _wire_curve.py), so a charm hung anywhere in the span meets the
  // wire rather than a fixed line.
  function wireCentreY(x){var d=x-314;return 345.6-0.0012518*d*d+0.003787*d}
  var WIRE_HALF_THICKNESS=9.5;
  // Where the hanging ring sits inside each charm cut-out, in image rows of the 260x260
  // asset, measured by _charm_ring_rows.py. Charms whose body starts straight away are
  // beads that slide on the wire, so their row is the middle of the body.
  // 23 is a heart bead whose bore sits high on the body, so its row is the bore, not the
  // body centre; 28 and 29 are round beads whose bore is the body centre.
  var CHARM_RING_ROW={
    20:21.5,21:20.0,22:20.0,23:100.0,24:61.5,25:52.0,26:68.5,27:52.0,28:130.0,
    29:130.0,30:41.5,31:48.0,32:51.0,33:54.0,34:57.5,36:64.0,37:56.5,38:54.0,
    39:27.5,40:30.0
  };
  var CHARM_RING_ROW_DEFAULT=52.0;
  var CHARM_RING_SCALE=94/260,CHARM_TILE_INSET=(112-94)/2;
  var LETTER_RING_ROW=12.0,LETTER_ASSET=120,LETTER_TILE=68;
  // A letter's own loop is decoration, not something a bangle can thread, so every letter
  // is hung on a proper charm bail: the sprite cropped from a metal charm, drawn at charm
  // size behind the letter, with the letter's own loop tucked under its bottom.
  var LETTER_BAIL=26/260*94, LETTER_BAIL_H=100/260*94, LETTER_BAIL_OVERLAP=2.5;
  function charmTileTop(item,x){
    var row=CHARM_RING_ROW[item.id];
    if(typeof row!=='number')row=CHARM_RING_ROW_DEFAULT;
    return wireCentreY(x)-CHARM_TILE_INSET-row*CHARM_RING_SCALE;
  }
  // [single charm, first of a pair, second of a pair]
  var CHARM_DEFAULT_X=[310,274,346];
  var CHARM_GROUP={
    20:'letters',21:'letters',22:'letters',
    23:'meaning',24:'meaning',25:'meaning',26:'keepers',27:'interests',
    28:'meaning',29:'keepers',30:'interests',31:'meaning',32:'meaning',
    33:'meaning',34:'interests',36:'interests',37:'meaning',38:'meaning',
    39:'meaning',40:'meaning'
  };
  var FILTERS=[
    ['all','All charms'],['letters','Initials'],['meaning','Meaning'],
    ['interests','Interests'],['keepers','Keepers']
  ];
  var state={bangle:false,beads:[],charms:[],filter:'all',pendingLetter:null};
  var $=function(id){return document.getElementById(id)};

  function esc(value){
    return String(value).replace(/[&<>"']/g,function(ch){
      return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[ch];
    });
  }
  function product(id){return INV.filter(function(p){return p.i===id})[0]}
  function countOf(items,id){return items.filter(function(item){return item.id===id}).length}
  function clampCharmX(x){return Math.max(CHARM_MIN_X,Math.min(CHARM_MAX_X,x))}
  function defaultCharmX(){
    if(!state.charms.length)return CHARM_DEFAULT_X[0];
    var moved=state.charms.some(function(item){return item.placed});
    if(!moved&&state.charms.length===1){
      state.charms[0].x=CHARM_DEFAULT_X[1];
      return CHARM_DEFAULT_X[2];
    }
    var used=state.charms.map(function(item){return typeof item.x==='number'?item.x:310});
    var best=CHARM_DEFAULT_X[0],bestGap=-1;
    CHARM_DEFAULT_X.forEach(function(candidate){
      var gap=1e9;
      used.forEach(function(x){gap=Math.min(gap,Math.abs(x-candidate))});
      if(gap>bestGap){bestGap=gap;best=candidate}
    });
    return clampCharmX(best);
  }
  function charmX(item,index,total){
    if(typeof item.x==='number')return clampCharmX(item.x);
    var fallback=STAGE_CHARM_SLOTS[total];
    return fallback?fallback[index]:310;
  }
  function nudgeCharm(item,step){
    if(!item)return;
    var from=typeof item.x==='number'?item.x:310;
    item.x=clampCharmX(from+step*CHARM_NUDGE);
    item.placed=true;
  }
  function fmtMm(value){return String(+(+value).toFixed(1)).replace(/\.0$/,'')}
  function money(value){return 'A$'+(+value).toFixed(2)}
  // Every selectable piece is one Shopify variant. Letter charms carry one variant per
  // letter, so the choice picks the variant; everything else has a single variant.
  function variantFor(item){
    var p=product(item.id);
    if(item.letter&&p.variants){
      for(var i=0;i<p.variants.length;i++){
        if(p.variants[i].title===item.letter)return p.variants[i];
      }
    }
    return {id:p.variant,title:p.title,price:p.price};
  }
  function priceFor(item){return +(variantFor(item).price||0)}
  function orderLines(){
    var lines=[];
    if(state.bangle)lines.push([BANGLE.title,+BANGLE.price]);
    if(state.beads.length)lines.push(['Crystal beads ×'+state.beads.length,
      state.beads.reduce(function(sum,item){return sum+priceFor(item)},0)]);
    if(state.charms.length)lines.push(['Metal charms ×'+state.charms.length,
      state.charms.reduce(function(sum,item){return sum+priceFor(item)},0)]);
    return lines;
  }
  function orderTotal(){
    return orderLines().reduce(function(sum,line){return sum+line[1]},0);
  }
  function numericId(gid){return +String(gid).split('/').pop()}
  function cartLines(){
    var tally={};
    var add=function(gid){var id=numericId(gid);tally[id]=(tally[id]||0)+1};
    if(state.bangle)add(BANGLE.variant);
    state.beads.forEach(function(item){add(variantFor(item).id)});
    state.charms.forEach(function(item){add(variantFor(item).id)});
    return Object.keys(tally).map(function(id){return {id:+id,quantity:tally[id]}});
  }
  function announce(message){
    var toast=$('toast');
    toast.classList.remove('action');
    toast.textContent=message;
    toast.classList.add('show');
    clearTimeout(toastTimer);
    toastTimer=setTimeout(function(){toast.classList.remove('show')},2600);
  }
  function smoothScroll(id){
    $(id).scrollIntoView({behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth',block:'start'});
  }

  function renderBangleChoice(){
    $('bangle-choice').innerHTML=
      '<article class="base-choice'+(state.bangle?' selected':'')+'">'+
        '<img src="'+BANGLE.img+'" alt="'+esc(BANGLE.title)+'">'+
        '<div><h3>'+esc(BANGLE.title)+'</h3>'+
        '<p class="meta">19 cm · 2.5 mm wire · two silicone-lined stopper beads</p>'+
        '<p class="meta">Gold plated over brass · waterproof · price pending</p></div>'+
        '<button class="secondary'+(state.bangle?' selected':'')+'" id="choose-bangle" type="button"'+(state.bangle?' disabled':'')+'>'+
        (state.bangle?'Selected ✓':'Choose this bangle')+'</button>'+
      '</article>';
    var choose=$('choose-bangle');
    if(!state.bangle){
      choose.addEventListener('click',function(){
        state.bangle=true;
        render();
        announce('Bangle selected. Crystal beads and charms are now unlocked.');
        smoothScroll('step-crystals');
      });
    }
  }

  function tile(p,kind){
    var items=kind==='bead'?state.beads:state.charms;
    var qty=countOf(items,p.i);
    var full=kind==='bead'?state.beads.length>=MAX_BEADS:state.charms.length>=MAX_CHARMS;
    var isLetter=CHARM_GROUP[p.i]==='letters';
    var label=qty?'Add another':(isLetter?'Choose initial':(kind==='bead'?'Add crystal':'Add charm'));
    var image=kind==='bead'?(p.singleImg||p.stageImg):p.img;
    var imageClass=kind==='bead'?' class="single-bead-image"':'';
    var imageAlt=kind==='bead'?'One bead preview: '+p.title:p.title;
    var typeCopy=kind==='bead'?('Adds 1 bead'+(p.sizeMm?' · '+fmtMm(p.sizeMm)+' mm':'')):p.type;
    return '<article class="product-tile'+(qty?' selected':'')+'" data-selected="'+(qty?'true':'false')+'" draggable="true" data-drag-kind="'+kind+'" data-drag-id="'+p.i+'">'+
      (qty?'<span class="qty-badge" aria-label="'+qty+' selected">'+qty+'</span>':'')+
      (kind==='bead'?'<span class="piece-badge">1 bead</span>':'')+
      '<img'+imageClass+' src="'+image+'" alt="'+esc(imageAlt)+'" loading="lazy" draggable="false">'+
      '<div class="product-copy"><h3>'+esc(p.title)+'</h3><p class="product-type">'+esc(typeCopy)+'</p>'+
      '<div class="tile-actions'+(qty?' has-selection':'')+'"><button class="add-button" type="button" data-add-'+kind+'="'+p.i+'"'+(full?' disabled':'')+'>'+label+'</button>'+
      (qty?'<button class="unselect-button" type="button" data-unselect-'+kind+'="'+p.i+'" aria-label="Unselect one '+esc(p.title)+'">Unselect</button>':'')+
      '</div></div>'+
      '</article>';
  }

  function renderInventory(){
    $('crystal-grid').innerHTML=BEADS.map(function(p){return tile(p,'bead')}).join('');
    var filtered=CHARMS.filter(function(p){return state.filter==='all'||CHARM_GROUP[p.i]===state.filter});
    $('charm-grid').innerHTML=filtered.map(function(p){return tile(p,'charm')}).join('');
  }

  function renderFilters(){
    $('charm-filters').innerHTML=FILTERS.map(function(f){
      return '<button class="filter-button" type="button" data-filter="'+f[0]+'" aria-pressed="'+(state.filter===f[0])+'">'+f[1]+'</button>';
    }).join('');
  }

  function renderLetters(){
    var panel=$('letter-panel');
    if(!state.pendingLetter){panel.hidden=true;return}
    var p=product(state.pendingLetter);
    panel.hidden=false;
    $('letter-copy').textContent='Selected style: '+p.title+'. Choose the letter to add.';
    var setAssets=LETTER_ASSETS[state.pendingLetter]||{};
    $('letters').innerHTML='ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('').map(function(letter){
      var asset=setAssets[letter];
      return '<button class="letter-button" type="button" data-letter="'+letter+'" aria-label="Letter '+letter+'">'+
        (asset?'<img src="'+asset+'" alt="">':letter)+'</button>';
    }).join('');
  }

  function selectedItem(item,index,total,kind){
    var p=product(item.id);
    var suffix=item.letter?' · '+item.letter:'';
    var image=kind==='bead'?(p.singleImg||p.stageImg):p.img;
    if(item.letter&&(LETTER_ASSETS[item.id]||{})[item.letter])image=LETTER_ASSETS[item.id][item.letter];
    var unit=kind==='bead'?(' · 1 bead'+(p.sizeMm?' · '+fmtMm(p.sizeMm)+' mm':'')):'';
    var isCharm=kind==='charm',atLeft,atRight;
    if(isCharm){
      var charmPos=typeof item.x==='number'?item.x:310;
      atLeft=charmPos<=CHARM_MIN_X+0.5;
      atRight=charmPos>=CHARM_MAX_X-0.5;
    }else{
      atLeft=index===0;
      atRight=index===total-1;
    }
    var caption=isCharm?'Drag to place it between the stopper beads'
      :'Position '+(index+1)+' of '+total+unit;
    return '<article class="selected-item">'+
      '<img src="'+image+'" alt="">'+
      '<div><strong>'+esc(p.title)+esc(suffix)+'</strong><small>'+caption+'</small></div>'+
      '<div class="order-controls">'+
        '<button class="order-button" type="button" data-order-kind="'+kind+'" data-order-index="'+index+'" data-order-move="-1" aria-label="Move '+esc(p.title)+' left'+(isCharm?' along the bangle':'')+'"'+(atLeft?' disabled':'')+'>←</button>'+
        '<button class="order-button" type="button" data-order-kind="'+kind+'" data-order-index="'+index+'" data-order-move="1" aria-label="Move '+esc(p.title)+' right'+(isCharm?' along the bangle':'')+'"'+(atRight?' disabled':'')+'>→</button>'+
        '<button class="order-button remove" type="button" data-remove-kind="'+kind+'" data-remove-index="'+index+'" aria-label="Remove '+esc(p.title)+'">×</button>'+
      '</div>'+
      '</article>';
  }

  function renderSelected(){
    $('selected-beads').innerHTML=state.beads.length?
      '<div class="selected-list">'+state.beads.map(function(item,i){return selectedItem(item,i,state.beads.length,'bead')}).join('')+'</div>':
      '<p class="empty-copy">No crystal beads selected yet.</p>';
    $('selected-charms').innerHTML=state.charms.length?
      '<div class="selected-list">'+state.charms.map(function(item,i){return selectedItem(item,i,state.charms.length,'charm')}).join('')+'</div>':
      '<p class="empty-copy">No charms selected yet.</p>';
  }

  function imagePart(p,x,y,w,h,multiply){
    return '<image href="'+p.stageImg+'" x="'+x+'" y="'+y+'" width="'+w+'" height="'+h+'" preserveAspectRatio="xMidYMid meet"'+(multiply?' style="mix-blend-mode:multiply"':'')+'/>';
  }
  function safeColour(p){
    return /^#[0-9a-f]{6}$/i.test(p.colour||'')?p.colour:'#d7d1c7';
  }
  var BEAD_BASE_MM=14;
  function beadSizeFactor(p){
    if(!p.sizeMm)return 1;
    return Math.max(.6,Math.min(1.6,p.sizeMm/BEAD_BASE_MM));
  }
  // Four listings are angular faceted blocks, not spheres. Their product photos show
  // flat cut faces and corners, so clipping them to an ellipse (the round-bead route)
  // made them read as plain round beads. These render through a polygon outline with
  // cut corners instead, at the aspect ratio of the actual stone, and their photo is
  // not rotated because a faceted block has no visible side drill hole to correct.
  var FACETED_BEADS={
    'faceted-citrine-barrel-beads':{rx:32,ry:35,outline:'block'},
    'rose-quartz-faceted-stone':{rx:40,ry:27,outline:'slab'},
    'faceted-amethyst-nugget-beads':{rx:35,ry:33,outline:'chunk'},
    'aquamarine-nugget-beads':{rx:38,ry:28,outline:'slab'}
  };
  var FACET_OUTLINES={
    slab:[[-1,-.42],[-.55,-1],[.45,-.95],[1,-.38],[1,.4],[.5,1],[-.5,.95],[-1,.45]],
    block:[[-1,-.36],[-.45,-1],[.5,-.96],[1,-.32],[.96,.38],[.42,1],[-.5,.96],[-1,.34]],
    chunk:[[-1,-.3],[-.5,-1],[.36,-.9],[1,-.26],[.94,.44],[.34,1],[-.55,.9],[-.96,.4]]
  };
  var FACET_LINES={
    slab:[[[-.55,-1],[-.32,1]],[[.45,-.95],[.2,1]],[[-1,-.05],[1,.12]]],
    block:[[[-.45,-1],[-.2,1]],[[.5,-.96],[.28,1]],[[-1,.02],[.96,-.08]]],
    chunk:[[[-.5,-1],[-.22,1]],[[.36,-.9],[.12,1]],[[-1,.08],[.94,-.02]],[[-.5,-1],[.94,-.26]]]
  };
  function facetSpec(p){return FACETED_BEADS[p.handle]||null}
  function facetPath(cx,cy,rx,ry,outline){
    return (FACET_OUTLINES[outline]||FACET_OUTLINES.slab).map(function(pt,i){
      return (i?'L':'M')+(cx+pt[0]*rx).toFixed(1)+' '+(cy+pt[1]*ry).toFixed(1);
    }).join(' ')+' Z';
  }
  function roundBeadShape(p,fit){
    var title=p.title.toLowerCase(),f=beadSizeFactor(p)*(fit||1);
    var facet=facetSpec(p);
    if(facet)return {rx:facet.rx*f,ry:facet.ry*f,texture:108*f,facet:facet.outline};
    var base={rx:36,ry:36};
    if(title.indexOf('rondelle')>-1)base={rx:36,ry:29};
    else if(title.indexOf('barrel')>-1)base={rx:36,ry:31};
    else if(/nugget|statement/.test(title))base={rx:36,ry:34};
    return {rx:base.rx*f,ry:base.ry*f,texture:108*f};
  }
  function beadLayout(){
    // Pack the selected beads around the stage centre using their true relative
    // widths. If a large combination exceeds the decorated zone, every bead is
    // shrunk by the same fit factor so relative millimetre scale is preserved.
    var GAP=6,MIN_X=206,MAX_X=414;
    var widths=state.beads.map(function(item){return 2*roundBeadShape(product(item.id)).rx});
    var gaps=GAP*Math.max(0,widths.length-1);
    var total=widths.reduce(function(a,b){return a+b},0)+gaps;
    var fit=Math.min(1,(MAX_X-MIN_X)/Math.max(total,1));
    var x=310-(total*fit)/2,centers=[];
    widths.forEach(function(w){
      var sw=w*fit;
      centers.push(x+sw/2);
      x+=sw+GAP*fit;
    });
    return {centers:centers,fit:fit};
  }
  function beadPart(item,cx,cy,index,total,opts){
    opts=opts||{};
    var p=product(item.id),shape=roundBeadShape(p,opts.fit);
    var clip='bead-clip-'+item.uid,shine='bead-shine-'+item.uid;
    var size=shape.texture,x=cx-size/2,y=cy-size/2;
    var cls=opts.cls||'stage-piece stage-bead';
    var wrap=opts.transform?' transform="'+opts.transform+'"':'';
    var thread='';
    if(index===0)thread+='<path d="M '+(cx-shape.rx-2)+' '+cy+' H '+(cx-shape.rx+10)+'" fill="none" stroke="#bb8e30" stroke-width="4" stroke-linecap="round"/>';
    if(index===total-1)thread+='<path d="M '+(cx+shape.rx-10)+' '+cy+' H '+(cx+shape.rx+2)+'" fill="none" stroke="#bb8e30" stroke-width="4" stroke-linecap="round"/>';
    var body,image,facetLines='';
    if(shape.facet){
      var d=facetPath(cx,cy,shape.rx,shape.ry,shape.facet);
      body=function(attrs){return '<path d="'+d+'" '+attrs+'/>'};
      // A faceted block is photographed face-on, so its texture is not rotated; the
      // box is sliced to the outline's bounding box so the polygon fills with stone.
      image='<image href="'+p.stageImg+'" x="'+(cx-shape.rx)+'" y="'+(cy-shape.ry)+'" width="'+(shape.rx*2)+'" height="'+(shape.ry*2)+'" preserveAspectRatio="xMidYMid slice" style="mix-blend-mode:multiply"/>';
      facetLines=(FACET_LINES[shape.facet]||[]).map(function(line,i){
        return '<path d="M '+(cx+line[0][0]*shape.rx).toFixed(1)+' '+(cy+line[0][1]*shape.ry).toFixed(1)+
          ' L '+(cx+line[1][0]*shape.rx).toFixed(1)+' '+(cy+line[1][1]*shape.ry).toFixed(1)+
          '" fill="none" stroke="'+(i%2?'#2b241a':'#fff')+'" stroke-opacity="'+(i%2?'.16':'.3')+'" stroke-width="1.1"/>';
      }).join('');
    }else{
      body=function(attrs){return '<ellipse cx="'+cx+'" cy="'+cy+'" rx="'+shape.rx+'" ry="'+shape.ry+'" '+attrs+'/>'};
      image='<image href="'+p.stageImg+'" x="'+x+'" y="'+y+'" width="'+size+'" height="'+size+'" preserveAspectRatio="xMidYMid meet" transform="rotate(90 '+cx+' '+cy+')" style="mix-blend-mode:multiply"/>';
    }
    var clipShape=shape.facet?'<path d="'+facetPath(cx,cy,shape.rx,shape.ry,shape.facet)+'"/>':
      '<ellipse cx="'+cx+'" cy="'+cy+'" rx="'+shape.rx+'" ry="'+shape.ry+'"/>';
    return '<defs><clipPath id="'+clip+'" clipPathUnits="userSpaceOnUse">'+clipShape+'</clipPath>'+
      '<radialGradient id="'+shine+'" cx="31%" cy="24%" r="76%"><stop offset="0" stop-color="#fff" stop-opacity=".48"/><stop offset=".38" stop-color="#fff" stop-opacity="0"/><stop offset="1" stop-color="#17130e" stop-opacity=".24"/></radialGradient></defs>'+
      '<g class="'+cls+'" data-piece-uid="'+item.uid+'" data-center-x="'+cx+'" data-center-y="'+cy+'"'+wrap+'>'+
        body('fill="'+safeColour(p)+'" fill-opacity=".94" style="filter:drop-shadow(0 4px 4px rgba(32,27,20,.2))"')+
        '<g clip-path="url(#'+clip+')">'+image+facetLines+'</g>'+
        body('fill="url(#'+shine+')"')+
        body('fill="none" stroke="#4c4336" stroke-opacity=".2" stroke-width="1.2"')+
        thread+
      '</g>';
  }
  function renderStage(){
    var active=state.bangle;
    var opacity=active?1:.42;
    var beadLayoutNow=beadLayout();
    var label=active?'Selected bangle': 'Choose the bangle to begin';
    if(state.beads.length){label+=', crystals from left to right: '+state.beads.map(function(i){return product(i.id).title}).join(', ')}
    if(state.charms.length){label+=', charms: '+state.charms.map(function(i){return product(i.id).title+(i.letter?' '+i.letter:'')}).join(', ')}
    var s='<title>'+esc(label)+'</title>'+
      '<image href="'+BANGLE.stageImg+'" x="0" y="0" width="620" height="470" preserveAspectRatio="xMidYMid slice" opacity="'+opacity+'"/>';
    if(active){
      if(!state.beads.length){
        [276,310,344].forEach(function(x){
          s+='<circle cx="'+x+'" cy="338" r="27" fill="#fff" fill-opacity=".78" stroke="#bdb6ac" stroke-width="1.5" stroke-dasharray="5 5"/>';
        });
      }else{
        state.beads.forEach(function(item,i){
          s+=beadPart(item,beadLayoutNow.centers[i],338,i,state.beads.length,{fit:beadLayoutNow.fit});
        });
      }
      if(!state.charms.length){
        s+='<path d="M310 378 v10" stroke="#bdb6ac" stroke-width="1.5" stroke-dasharray="4 5"/>'+
          '<circle cx="310" cy="409" r="18" fill="#fff" fill-opacity=".78" stroke="#bdb6ac" stroke-width="1.5" stroke-dasharray="4 5"/>';
      }else{
        state.charms.forEach(function(item,i){
          var p=product(item.id),x=charmX(item,i,state.charms.length);
          if(item.letter){
            var letterAsset=(LETTER_ASSETS[item.id]||{})[item.letter];
            if(letterAsset){
              // Hang the bail through the letter's own loop: the bail is centred on the
              // loop's x, and the letter drops until that loop sits on the bail's bottom.
              var loop=((LETTER_RINGS.positions[String(item.id)]||{})[item.letter]
                        || [60,20]);
              var lscale=LETTER_TILE/LETTER_ASSET;
              var bailX=x-LETTER_TILE/2+loop[0]*lscale;
              var letterTop=wireCentreY(x)+LETTER_BAIL_H/2-LETTER_BAIL_OVERLAP
                            -loop[1]*lscale;
              s+='<g class="stage-piece stage-charm" data-piece-uid="'+item.uid+'" data-center-x="'+x+'" data-center-y="357">'+
                '<image href="'+LETTER_RINGS.sprite+'" x="'+(bailX-LETTER_BAIL/2)+'" y="'+(wireCentreY(x)-LETTER_BAIL_H/2)+'" width="'+LETTER_BAIL+'" height="'+LETTER_BAIL_H+'" preserveAspectRatio="xMidYMid meet"/>'+
                '<image href="'+letterAsset+'" x="'+(x-LETTER_TILE/2)+'" y="'+letterTop+'" width="'+LETTER_TILE+'" height="'+LETTER_TILE+'" preserveAspectRatio="xMidYMid meet"/></g>';
            }else{
            s+='<g class="stage-piece stage-charm" data-piece-uid="'+item.uid+'" data-center-x="'+x+'" data-center-y="357">'+
                '<circle cx="'+x+'" cy="'+(wireCentreY(x)+WIRE_HALF_THICKNESS-5)+'" r="7" fill="none" stroke="#9a7126" stroke-width="3"/>'+
                '<text x="'+x+'" y="417" text-anchor="middle" font-family="Georgia,serif" font-size="54" font-weight="700" fill="#c69b42" stroke="#805a18" stroke-width=".8">'+esc(item.letter)+'</text></g>';
            }
          }else{
            s+='<g class="stage-piece stage-charm" data-piece-uid="'+item.uid+'" data-center-x="'+x+'" data-center-y="357">'+imagePart(p,x-47,charmTileTop(item,x),94,112)+'</g>';
          }
        });
      }
    }else{
      s+='<text x="310" y="424" text-anchor="middle" fill="#625e58" font-size="16" font-family="system-ui,sans-serif">Choose the bangle to unlock your pieces</text>';
    }
    $('bangle-stage').innerHTML=s;
    $('bangle-stage').setAttribute('aria-label',label);
    var mini=$('mini-stage');
    if(mini)mini.innerHTML=s.replace(/id="/g,'id="m-').replace(/url\(#/g,'url(#m-');
  }

  function renderSummary(){
    var beadNames=state.beads.map(function(i){return product(i.id).title});
    var charmNames=state.charms.map(function(i){return product(i.id).title+(i.letter?' '+i.letter:'')});
    var beadTotal=state.beads.reduce(function(sum,item){return sum+priceFor(item)},0);
    var charmTotal=state.charms.reduce(function(sum,item){return sum+priceFor(item)},0);
    $('selection-summary').innerHTML=
      '<div class="summary-line"><span>Bangle</span><strong>'+(state.bangle?'Selected <em>'+money(BANGLE.price)+'</em>':'Not selected')+'</strong></div>'+
      '<div class="summary-line"><span>Crystals</span><strong>'+(beadNames.length?esc(beadNames.join(' · '))+' <em>'+money(beadTotal)+'</em>':'None yet')+'</strong></div>'+
      '<div class="summary-line"><span>Charms</span><strong>'+(charmNames.length?esc(charmNames.join(' · '))+' <em>'+money(charmTotal)+'</em>':'None yet')+'</strong></div>'+
      '<div class="summary-line summary-total"><span>Total</span><strong>'+money(orderTotal())+'</strong></div>';
    var pill=$('status-pill');
    pill.textContent=state.bangle?(state.beads.length||state.charms.length?'Design in progress':'Bangle ready'):'Choose bangle';
    pill.classList.toggle('ready',state.bangle);
    var cart=$('cart-button');
    cart.disabled=!state.bangle;
    if(cart.getAttribute('aria-busy')!=='true'){
      cart.textContent=state.bangle
        ?'Add to cart · '+money(orderTotal())
        :'Choose the bangle to continue';
    }
    $('clear-button').hidden=!(state.beads.length||state.charms.length);
    $('assembly-button').disabled=!(state.bangle&&(state.beads.length||state.charms.length));
    var miniMeta=$('mini-meta');
    if(miniMeta){
      miniMeta.textContent=state.bangle?
        ('Bangle · '+state.beads.length+'/'+MAX_BEADS+' beads · '+state.charms.length+'/'+MAX_CHARMS+' charms'):
        'Bangle not selected';
    }
    $('drag-hint').hidden=!(state.beads.length||state.charms.length);
  }

  function reducedMotion(){
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }
  function animatePiece(piece,delay){
    if(!piece||!piece.animate)return null;
    var cx=+piece.dataset.centerX,cy=+piece.dataset.centerY;
    var rect=$('bangle-stage').getBoundingClientRect();
    var sx=rect.width/620,sy=rect.height/470;
    if(reducedMotion()){
      return piece.animate([{opacity:.35},{opacity:1}],{duration:140,delay:delay||0,easing:'linear',fill:'both'});
    }
    var point=function(x,y){return 'translate('+((x-cx)*sx)+'px,'+((y-cy)*sy)+'px)'};
    var isCharm=piece.classList.contains('stage-charm');
    var keyframes=[
      {transform:point(470,101)+' scale(.72) rotate(-10deg)',opacity:0,offset:0},
      {transform:point(525,214)+' scale(.82) rotate(-5deg)',opacity:1,offset:.34},
      {transform:point(456,318)+' scale(.94) rotate('+(isCharm?'5':'2')+'deg)',opacity:1,offset:.74},
      {transform:'translate(0,0) scale(1) rotate(0deg)',opacity:1,offset:1}
    ];
    return piece.animate(keyframes,{duration:isCharm?1120:980,delay:delay||0,easing:'cubic-bezier(.22,1,.36,1)',fill:'both'});
  }
  function restoreAssemblyButton(run){
    if(run!==assemblyRun)return;
    var button=$('assembly-button');
    button.innerHTML='<span aria-hidden="true">▶</span> Play assembly';
    button.removeAttribute('aria-busy');
    button.disabled=!(state.beads.length||state.charms.length);
  }
  function playAssembly(){
    var pieces=Array.prototype.slice.call(document.querySelectorAll('#bangle-stage .stage-piece'));
    if(!pieces.length)return;
    var run=++assemblyRun,button=$('assembly-button');
    button.textContent='Playing…';
    button.setAttribute('aria-busy','true');
    button.disabled=true;
    pieces.forEach(function(piece){piece.getAnimations().forEach(function(animation){animation.cancel()})});
    var animations=pieces.map(function(piece,index){return animatePiece(piece,reducedMotion()?0:index*190)}).filter(Boolean);
    Promise.all(animations.map(function(animation){return animation.finished.catch(function(){})})).then(function(){restoreAssemblyButton(run)});
    announce('Assembly demo playing. Each piece threads in from the open tip.');
  }
  function animateLatest(uidValue){
    window.requestAnimationFrame(function(){
      var piece=document.querySelector('#bangle-stage [data-piece-uid="'+uidValue+'"]');
      if(piece)animatePiece(piece,0);
    });
  }

  function renderProgress(){
    var current=!state.bangle?'bangle':(state.beads.length<MAX_BEADS?'beads':'charms');
    document.querySelectorAll('[data-progress]').forEach(function(li){
      var step=li.dataset.progress;
      var done=(step==='bangle'&&state.bangle)||(step==='beads'&&state.beads.length===MAX_BEADS);
      li.classList.toggle('done',done);
      li.classList.toggle('active',step===current&&!done);
      li.querySelector('.num').textContent=done?'✓':(step==='bangle'?'1':step==='beads'?'2':'3');
    });
  }

  function renderLocks(){
    ['step-crystals','step-charms'].forEach(function(id){
      var section=$(id),locked=!state.bangle;
      section.classList.toggle('locked',locked);
      section.setAttribute('aria-disabled',String(locked));
      section.inert=locked;
    });
  }

  function renderCounts(){
    $('bead-count').textContent=state.beads.length+' / '+MAX_BEADS;
    $('charm-count').textContent=state.charms.length+' / '+MAX_CHARMS;
  }

  function render(){
    renderBangleChoice();
    renderLocks();
    renderFilters();
    renderLetters();
    renderInventory();
    renderSelected();
    renderStage();
    renderSummary();
    renderProgress();
    renderCounts();
  }

  function addBead(id){
    if(!state.bangle)return;
    if(state.beads.length>=MAX_BEADS){announce('Three crystal positions are already filled. Remove one to add another.');return}
    var item={id:id,uid:++uid};
    state.beads.push(item);
    render();
    animateLatest(item.uid);
    announce(product(id).title+' added to crystal position '+state.beads.length+'.');
  }
  function addCharm(id,letter){
    if(!state.bangle)return;
    if(state.charms.length>=MAX_CHARMS){announce('Two charm positions are already filled. Remove one to add another.');return}
    var item={id:id,uid:++uid,letter:letter||null,x:defaultCharmX()};
    state.charms.push(item);
    state.pendingLetter=null;
    render();
    animateLatest(item.uid);
    announce(product(id).title+(letter?' '+letter:'')+' added.');
  }
  function unselectOne(kind,id){
    var list=kind==='bead'?state.beads:state.charms;
    for(var index=list.length-1;index>=0;index--){
      if(list[index].id!==id)continue;
      var removed=list.splice(index,1)[0];
      if(state.pendingLetter===id)state.pendingLetter=null;
      var remaining=countOf(list,id);
      render();
      var grid=kind==='bead'?$('crystal-grid'):$('charm-grid');
      var action=remaining?'unselect':'add';
      var next=grid.querySelector('[data-'+action+'-'+kind+'="'+id+'"]');
      if(next)next.focus({preventScroll:true});
      announce(product(id).title+(removed.letter?' '+removed.letter:'')+' unselected.'+(remaining?' '+remaining+' still selected.':''));
      return;
    }
  }

  $('crystal-grid').addEventListener('click',function(event){
    var unselect=event.target.closest('[data-unselect-bead]');
    if(unselect){unselectOne('bead',+unselect.dataset.unselectBead);return}
    var button=event.target.closest('[data-add-bead]');
    if(button)addBead(+button.dataset.addBead);
  });
  $('charm-grid').addEventListener('click',function(event){
    var unselect=event.target.closest('[data-unselect-charm]');
    if(unselect){unselectOne('charm',+unselect.dataset.unselectCharm);return}
    var button=event.target.closest('[data-add-charm]');
    if(!button)return;
    var id=+button.dataset.addCharm;
    if(CHARM_GROUP[id]==='letters'){
      state.pendingLetter=id;
      renderLetters();
      var first=$('letters').querySelector('button');
      if(first)first.focus();
    }else addCharm(id,null);
  });
  $('charm-filters').addEventListener('click',function(event){
    var button=event.target.closest('[data-filter]');
    if(!button)return;
    state.filter=button.dataset.filter;
    state.pendingLetter=null;
    renderFilters();
    renderLetters();
    renderInventory();
  });
  $('letters').addEventListener('click',function(event){
    var button=event.target.closest('[data-letter]');
    if(button&&state.pendingLetter)addCharm(state.pendingLetter,button.dataset.letter);
  });
  document.addEventListener('click',function(event){
    var order=event.target.closest('[data-order-kind]');
    if(order){
      var list=order.dataset.orderKind==='bead'?state.beads:state.charms;
      var from=+order.dataset.orderIndex,step=+order.dataset.orderMove;
      if(order.dataset.orderKind==='charm'){
        nudgeCharm(list[from],step);
        render();
        announce('Charm moved '+(step<0?'left':'right')+' along the bangle.');
        return;
      }
      var to=from+step;
      if(to>=0&&to<list.length){var moved=list.splice(from,1)[0];list.splice(to,0,moved);render();announce('Order updated.')}
      return;
    }
    var remove=event.target.closest('[data-remove-kind]');
    if(remove){
      var target=remove.dataset.removeKind==='bead'?state.beads:state.charms;
      var removed=target.splice(+remove.dataset.removeIndex,1)[0];
      render();
      announce(product(removed.id).title+' removed.');
    }
  });
  var undoState=null;
  function offerUndo(){
    var toast=$('toast');
    toast.innerHTML='All pieces cleared. The bangle stays selected. <button class="toast-undo" id="toast-undo" type="button">Undo</button>';
    toast.classList.add('show','action');
    $('toast-undo').addEventListener('click',function(){
      if(!undoState)return;
      state.beads=undoState.beads;
      state.charms=undoState.charms;
      undoState=null;
      render();
      announce('Selections restored.');
      var clear=$('clear-button');
      if(clear&&!clear.hidden)clear.focus({preventScroll:true});
    });
    $('toast-undo').focus({preventScroll:true});
    clearTimeout(toastTimer);
    toastTimer=setTimeout(function(){
      var undoButton=$('toast-undo');
      if(undoButton&&document.activeElement===undoButton)$('cart-button').focus({preventScroll:true});
      toast.classList.remove('show','action');
      undoState=null;
    },8000);
  }
  $('clear-button').addEventListener('click',function(){
    if(!state.beads.length&&!state.charms.length)return;
    undoState={beads:state.beads.slice(),charms:state.charms.slice()};
    state.beads=[];state.charms=[];state.pendingLetter=null;
    render();
    offerUndo();
  });
  $('assembly-button').addEventListener('click',playAssembly);

  var STAGE_CHARM_SLOTS={1:[310],2:[274,346]};
  var DRAG_REMOVE_DISTANCE=90;
  var dragState=null;
  function stagePoint(event){
    var rect=$('bangle-stage').getBoundingClientRect();
    return {
      x:(event.clientX-rect.left)*620/rect.width,
      y:(event.clientY-rect.top)*470/rect.height
    };
  }
  $('bangle-stage').addEventListener('pointerdown',function(event){
    var piece=event.target.closest('.stage-piece');
    if(!piece)return;
    var isBead=piece.classList.contains('stage-bead');
    var list=isBead?state.beads:state.charms;
    if(!list.length)return;
    var uid=+piece.dataset.pieceUid,index=-1;
    list.forEach(function(item,i){if(item.uid===uid)index=i});
    if(index<0)return;
    event.preventDefault();
    piece.getAnimations().forEach(function(animation){animation.cancel()});
    try{$('bangle-stage').setPointerCapture(event.pointerId)}catch(captureError){}
    var start=stagePoint(event);
    dragState={
      list:list,
      slots:isBead?beadLayout().centers:STAGE_CHARM_SLOTS[list.length],
      index:index,piece:piece,
      isBead:isBead,
      startX:start.x,startY:start.y,
      pointerId:event.pointerId
    };
    piece.classList.add('dragging');
  });
  $('bangle-stage').addEventListener('pointermove',function(event){
    if(!dragState||event.pointerId!==dragState.pointerId)return;
    var point=stagePoint(event);
    var dx=point.x-dragState.startX,dy=point.y-dragState.startY;
    dragState.piece.style.transform='translate('+dx+'px,'+dy+'px)';
    dragState.piece.classList.toggle('drag-remove',Math.abs(dy)>DRAG_REMOVE_DISTANCE);
  });
  function endStageDrag(event){
    if(!dragState||event.pointerId!==dragState.pointerId)return;
    var drag=dragState;
    dragState=null;
    drag.piece.classList.remove('dragging');
    var point=stagePoint(event);
    if(Math.abs(point.y-drag.startY)>DRAG_REMOVE_DISTANCE){
      var removed=drag.list.splice(drag.index,1)[0];
      if(state.pendingLetter===removed.id)state.pendingLetter=null;
      render();
      announce(product(removed.id).title+(removed.letter?' '+removed.letter:'')+' removed. Its card can add it back.');
      return;
    }
    var centerX=+drag.piece.dataset.centerX+(point.x-drag.startX);
    if(!drag.isBead){
      drag.list[drag.index].x=clampCharmX(centerX);
      drag.list[drag.index].placed=true;
      render();
      announce('Charm placed between the stopper beads.');
      return;
    }
    var nearest=0;
    drag.slots.forEach(function(x,i){
      if(Math.abs(x-centerX)<Math.abs(drag.slots[nearest]-centerX))nearest=i;
    });
    if(nearest!==drag.index){
      var moved=drag.list.splice(drag.index,1)[0];
      drag.list.splice(nearest,0,moved);
      render();
      announce('Position updated.');
    }else{
      render();
    }
  }
  $('bangle-stage').addEventListener('pointerup',endStageDrag);
  $('bangle-stage').addEventListener('pointercancel',endStageDrag);

  document.addEventListener('dragstart',function(event){
    var tile=event.target.closest?event.target.closest('[data-drag-kind]'):null;
    if(!tile||!state.bangle)return;
    event.dataTransfer.setData('text/plain',tile.dataset.dragKind+':'+tile.dataset.dragId);
    event.dataTransfer.effectAllowed='copy';
  });
  (function(){
    var card=$('preview-card');
    card.addEventListener('dragover',function(event){
      if(!state.bangle)return;
      event.preventDefault();
      event.dataTransfer.dropEffect='copy';
      card.classList.add('drop-ready');
    });
    card.addEventListener('dragleave',function(){card.classList.remove('drop-ready')});
    card.addEventListener('drop',function(event){
      event.preventDefault();
      card.classList.remove('drop-ready');
      var data=(event.dataTransfer.getData('text/plain')||'').split(':');
      if(data[0]==='bead'){
        addBead(+data[1]);
      }else if(data[0]==='charm'){
        var id=+data[1];
        if(CHARM_GROUP[id]==='letters'){
          state.pendingLetter=id;
          renderLetters();
          var first=$('letters').querySelector('button');
          if(first)first.focus();
        }else{
          addCharm(id,null);
        }
      }
    });
  })();

  // Sends the design to the Shopify cart as one line per variant, then hands over to
  // Shopify's own checkout. Nothing is charged here; the store's checkout does that.
  function startCheckout(){
    var button=$('cart-button');
    if(!state.bangle||button.getAttribute('aria-busy')==='true')return;
    var items=cartLines();
    if(!items.length)return;
    button.disabled=true;
    button.setAttribute('aria-busy','true');
    button.textContent='Adding to cart…';
    fetch('/cart/add.js',{method:'POST',
      headers:{'Content-Type':'application/json','Accept':'application/json'},
      body:JSON.stringify({items:items})})
      .then(function(response){
        return response.json().catch(function(){return {}}).then(function(data){
          if(!response.ok)throw new Error(data.description||data.message||'the cart rejected the design');
          return data;
        });
      })
      .then(function(){window.location.href='/checkout'})
      .catch(function(error){
        button.disabled=false;
        button.removeAttribute('aria-busy');
        button.textContent='Add to cart · '+money(orderTotal());
        announce('Sorry, checkout could not start: '+error.message+'. Please try again.');
      });
  }
  $('cart-button').addEventListener('click',startCheckout);

  if(!BANGLE||BEADS.length<10||CHARMS.length<10){
    document.body.innerHTML='<main class="shell"><section class="intro"><h1>Inventory needs attention.</h1><p>The builder expected one bangle plus the active crystal bead and metal charm listings. Refresh the Shopify inventory before continuing.</p></section></main>';
    throw new Error('Inventory safety check failed');
  }
  $('stock-note').textContent='1 bangle · '+BEADS.length+' crystal choices · '+CHARMS.length+' active charms';
  $('mini-preview').addEventListener('click',function(){smoothScroll('preview-card')});
  if('IntersectionObserver' in window){
    new IntersectionObserver(function(entries){
      var entry=entries[0];
      var passed=!entry.isIntersecting&&entry.boundingClientRect.top<0;
      $('mini-preview').classList.toggle('on',passed);
    },{threshold:0}).observe($('preview-card'));
  }
  var params=new URLSearchParams(window.location.search);
  if(params.get('embed')==='1'){
    document.body.classList.add('embedded');
    var reportHeight=function(){
      var height=Math.ceil(document.documentElement.getBoundingClientRect().height);
      if(window.parent!==window)window.parent.postMessage({sunroongaBuilderHeight:height},'*');
    };
    if('ResizeObserver' in window)new ResizeObserver(reportHeight).observe(document.body);
    window.addEventListener('load',reportHeight);
    window.setInterval(reportHeight,1000);
    reportHeight();
  }
  if(params.get('demo')==='1'){
    state.bangle=true;
    [6,3,4].forEach(function(id){state.beads.push({id:id,uid:++uid})});
    render();
    window.setTimeout(playAssembly,350);
  }else{
    render();
  }
})();

}catch(err){console.error('Bangle builder failed:',err)}
  }
  function ready(){
    if(window.SUNROONGA_BUILDER_DATA)start();
    else window.addEventListener('sunroonga-builder-data',start);
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',ready);
  else ready();
})();
